<template>
    <div
        :class="`DshDate ycFormItem control-${mode}`"
        v-if="show"
    >
        <!-- <template
            v-if="canEdit"> -->
        <template v-if="['time'].includes(propsObj._dateType)">
            <TimePicker
                style="width: 100%;"
                v-model="formatVal"
                :class="{
                    'DshDate-time-readonly': $isReadonly(canEdit, propsObj),
                    'DshDate-time-disabled': $isDisabled(canEdit, propsObj)
                }"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
                :type="propsObj._dateType"
                :disabled="!finalCanEdit"
                :clearable="true"
                :transfer="true"
                @on-change="change"
            ></TimePicker>
        </template>
        <template v-else>
            <DatePicker
                style="width: 100%;"
                v-model="formatVal"
                :class="{
                        'DshDate-date-readonly': $isReadonly(canEdit, propsObj),
                        'DshDate-date-disabled': $isDisabled(canEdit, propsObj)
                    }"
                :placeholder="$showPlaceholder(canEdit, propsObj) ? `请输入${propsObj._name}` : ''"
                :type="propsObj._dateType"
                :disabled="!finalCanEdit"
                :clearable="true"
                :transfer="true"
                @on-change="change"
            ></DatePicker>
        </template>
    </div>
</template>

<script>
    import controlMixin from "../controlMixin.js";

    export default {
        name: "DshDate",
        mixins: [controlMixin],
        props: {},
        data () {
            return {
                show: true
            };
        },
        computed: {
            formatVal: {
                get () {
                    let dateVal;
                    if (this.value[this.propsObj._key] && !Array.isArray(this.value[this.propsObj._key]) && this.propsObj._dateType !== "time") {
                        if (typeof this.value[this.propsObj._key] === "string") {
                            // safari兼容处理,new Date需要将字符串中的-变为/，整月需要增加日期为01
                            if (this.propsObj._dateType === "month") {
                                dateVal = new Date(`${this.value[this.propsObj._key]}-01`.replace(/-/g, "/"));
                            } else {
                                dateVal = new Date(this.value[this.propsObj._key].replace(/-/g, "/"));
                            }
                        } else {
                            dateVal = new Date(this.value[this.propsObj._key]);
                        }
                    } else {
                        dateVal = this.value[this.propsObj._key];
                    }
                    return dateVal;
                },
                set (val) {
                    this.value[this.propsObj._key] = val;
                }
            }
        },
        created () {
        },
        methods: {
        },
        watch: {
            "propsObj._dateType" () {
                this.show = false;
                this.$nextTick(() => {
                    this.value[this.propsObj._key] = this.propsObj._default;
                    this.show = true;
                });
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshDate {
        width: 100%;
    }
</style>
<style lang="less">
    .DshDate {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/controls/base/DshDate.vue